
@if(this.userAuthService.checkPermission('MANAGE.SERVICES.ENVIRONMENTS.ADD')){
  <div class="mt-2 pr-0 col-12 d-flex justify-content-end align-items-center mb-05">
  <button class="add-service-btn" (click)="addService()">+ Add Service
    <mat-icon mat-icon-button matSuffix matTooltip="Click on the button to add a new service"
              aria-hidden="true" matTooltipClass="ey-custom-tooltip"
              matTooltipPosition="below" style="margin-bottom: -3px;  align-items: center; vertical-align: middle; font-size: 18px;">
              info
            </mat-icon>
  </button>
  </div>
}
<div class="service-main-container" id = "service-list">
  <ag-grid-angular #agGrid [style]="styleChipDiv" [infiniteInitialRowCount]="infiniteInitialRowCount"
  class="ag-theme-material service-managementt-grid"
    [rowHeight]="rowHeight" (gridReady)="onGridReady($event)" [columnDefs]="columnDefs" id="gridservice"
    [defaultColDef]="defaultColDef" [cacheBlockSize]="cacheBlockSize" [maxBlocksInCache]="maxBlocksInCache"
    [rowModelType]="rowModelType" [sideBar]="sideBar"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate" [gridOptions]="gridOptions"
    (cellClicked)="tableMenuClick($event, $event.data, contextMenu,serviceMenuTemplate)">
  </ag-grid-angular>
 

</div>
<ng-template #serviceMenuTemplate let-service>
  <div>
    <ul class="mdc-list demo-list mdc-elevation--z2 b-white">
      @if(service.extraProperties.allowModify && this.userAuthService.checkPermission('MANAGE.SERVICES.ENVIRONMENTS.MODIFY')) {
      <li class="service-menu-item" (click)="updateService(service.extraProperties)" (keydown)="noop()">
        <i class="material-icons-outlined" aria-hidden="true"
          style="width:20px; height:20px; vertical-align:middle; margin-right:8px;">edit</i>
        <span> Modify </span>
      </li>
      }
      <li class="service-menu-item" (click)="githubDetails(service.extraProperties)" (keydown)="noop()">   <!-- //NOSONAR -->
        <img src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" alt="GitHub Logo"
             style="width:20px; height:20px; vertical-align:middle; margin-right:8px;">
        <span> Github Details </span>
      </li>
    </ul>
  </div>
</ng-template>

<app-slider [sliderId]="serviceSliderId" 
  [sliderHeader]="(editmode == true) ? 'Modify Service' :  'Add Service' " (closeSliderFunc)="closeNav()">
  @if(editmode == false){
  <div>
    <app-add-modify-service-config (closeSlider)=closeNav() [allServices]="allServices"></app-add-modify-service-config>
  </div>
  }
  @if(editmode == true){
  <div>
    <app-add-modify-service-config (closeSlider)=closeNav() [data]="selectedService"></app-add-modify-service-config>
  </div>
  }
  <ng-content></ng-content>

</app-slider>
